/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC } from 'react';
import { Nullable } from 'primereact/ts-helpers';
import { InputDateField } from '@/components';

import { useTranslation } from 'react-i18next';

import styles from './DocumentsWebFilter.module.scss';
import { TableFilters } from './TableFiltersType';

type DocumentsWebTableFiltersProps = {
  filters: TableFilters;
  setFilters: (filters: TableFilters) => void;
};

const DocumentsWebFilters: FC<DocumentsWebTableFiltersProps> = ({
  filters,
  setFilters,
}) => {
  const { t } = useTranslation('tableFilters');

  const handleFilterChange = (
    value: string | Nullable<Date>,
    field: keyof TableFilters
  ) => {
    const newFilters = {
      ...filters,
      [field]: value,
    };

    setFilters(newFilters);
  };

  const today = new Date();

  return (
    <div className={styles.filtersContainer}>
      <InputDateField
        id="startAt"
        name="startAt"
        value={filters.fechaDesde}
        onChange={(e) => handleFilterChange(e, 'fechaDesde')}
        label={t('startAt')}
        className={styles.dateField}
        readOnlyInput
        maxDate={today}
      />
      <InputDateField
        id="endAt"
        name="endAt"
        value={filters.fechaHasta}
        onChange={(e) => handleFilterChange(e, 'fechaHasta')}
        label={t('endAt')}
        className={styles.dateField}
        readOnlyInput
        maxDate={today}
      />
    </div>
  );
};

export default DocumentsWebFilters;
